// extracted by mini-css-extract-plugin
export default {"pageContainer":"common_pageContainer__44nUe","pageWrapper":"common_pageWrapper__owgNA","languageSelectorContainer":"common_languageSelectorContainer__iccNf"};